import script from "./CommonForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonForm.vue?vue&type=script&lang=ts&setup=true"

import "./CommonForm.vue?vue&type=style&index=0&id=7e58a368&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e58a368"]])

export default __exports__